export default "__VITE_ASSET__sxvBH78b__"